import {
  Text,
  Button,
  AlertDialog,
  AlertDialogOverlay,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogBody,
  AlertDialogFooter,
  // CheckboxGroup,
  Input,
  FormControl,
  FormLabel,
  OrderedList,
  ListItem,
  UnorderedList,
  Center,
  // TableContainer,
  // IconButton,
} from "@chakra-ui/react";

import React, { useEffect, useState } from "react";
// import Strings from '../../config/Strings';
import {ReactComponent as ICPIcon} from './icp.svg';
import Strings2 from "../config/Strings2";

export default function InternetIdentityAuthAlert({ onCompleted, disclosure }) {
  return (
    <AlertDialog
      // size={""}
      size={"lg"}
      
      isOpen={disclosure.isOpen}
      closeOnOverlayClick={true}
    >
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader fontSize="lg" fontWeight="bold">
            {Strings2.ii_intro_alert.title}
          </AlertDialogHeader>

          <AlertDialogBody fontSize={"sm"}>
            <Center paddingY={4}>
            <ICPIcon width={"64px"} />
            </Center>

            <Text fontWeight={"bold"}>
            {Strings2.ii_intro_alert.body.line1}
            </Text>

            <br />
            <UnorderedList>
              <ListItem>
                <Text>
                {Strings2.ii_intro_alert.body.line2}
                </Text>
              </ListItem>

            </UnorderedList>

          </AlertDialogBody>

          <AlertDialogFooter>
            <Button
              mr={4}
              colorScheme={"green"}
              onClick={() => {
                onCompleted(false);
                disclosure.onClose();
              }}
            >
              {Strings2.ii_intro_alert.footer.cancel}
            </Button>

            <Button
              mr={4}
              colorScheme={"red"}
              onClick={() => {
                onCompleted(true);
                disclosure.onClose();
              }}
            >
              {Strings2.ii_intro_alert.footer.next}
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
}
